
import EditDemandTable  from './EditDemandTable';
import { useState }     from 'react';

const EditDemandTableContainer = ({
    
    demandPostData, 
    newValues, 
    setNewValues
    
}) => {

    const handleChangeValue = (id, newValue) => {
        
        setNewValues(prev => {
            
            const exists = prev.find(item => item.id === id)

            if (exists) {
                return prev.map(item =>
                    item.id === id ? { ...item, newValue } : item
                )
            }

            return [...prev, { id, newValue }]
        })
        
    }

    return (
        <>

            <EditDemandTable 

                demandPostData={demandPostData} 
                onChangeValue={(id, newValue) => handleChangeValue(id, newValue)}
                newValues={newValues}

            />

        </>
    )
}

export default EditDemandTableContainer;